import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const investmentOfferTypesCondo = require("../images/types/condo.jpg");
const investmentOfferTypesRent = require("../images/types/rent.jpg");
const investmentOfferTypesHoliday = require("../images/types/holiday.jpg");

export const useInvestmentOfferTypes = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats) ?? {
        totals: {
            is_condohotel: 0,
            is_holiday_location: 0,
            is_dedicated_for_rent: 0
        }
    };

    return [
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.CONDOHOTEL}),
            offersCount: stats.totals.is_condohotel,
            image: investmentOfferTypesCondo,
            title: "Condohotele",
            text: "Oferty z obsługą operatorską oraz gwarantowaną stopą zwrotu z inwestycji"
        },
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.HOLIDAY}),
            offersCount: stats.totals.is_holiday_location,
            image: investmentOfferTypesHoliday,
            title: "Apartamenty wakacyjne",
            text: "Wypoczywaj i jednocześnie zarabiaj na swojej nieruchomości"
        },
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.FOR_RENT}),
            offersCount: stats.totals.is_dedicated_for_rent,
            image: investmentOfferTypesRent,
            title: "Pod wynajem",
            text: "Osiągaj maksymalne zyski inwestując w nieruchomości"
        }
    ];
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const investmentOfferTypesCondo = require("../images/types/condo.jpg");
const investmentOfferTypesRent = require("../images/types/rent.jpg");
const investmentOfferTypesHoliday = require("../images/types/holiday.jpg");

export const useInvestmentOfferTypes = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats) ?? {
        totals: {
            is_condohotel: 0,
            is_holiday_location: 0,
            is_dedicated_for_rent: 0
        }
    };

    return [
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.CONDOHOTEL}),
            offersCount: stats.totals.is_condohotel,
            image: investmentOfferTypesCondo,
            title: "Condohotele",
            text: "Oferty z obsługą operatorską oraz gwarantowaną stopą zwrotu z inwestycji"
        },
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.HOLIDAY}),
            offersCount: stats.totals.is_holiday_location,
            image: investmentOfferTypesHoliday,
            title: "Apartamenty wakacyjne",
            text: "Wypoczywaj i jednocześnie zarabiaj na swojej nieruchomości"
        },
        {
            href: rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.FOR_RENT}),
            offersCount: stats.totals.is_dedicated_for_rent,
            image: investmentOfferTypesRent,
            title: "Pod wynajem",
            text: "Osiągaj maksymalne zyski inwestując w nieruchomości"
        }
    ];
};
